/*
 * @Descripttion: 登录端口常量
 * @version:
 * @Author: gjqiang
 * @Date: 2021-4-6 10:24:54
 */
export const JINDUO_DESIGN_BMS = 1
export const PLATFORM_BMS = 2
export const STORE_BMS = 3
export const ZHEJIANG_BMS = 4
export const PRODUCT_CENTER_BMS = 5

export const SUERP_ADMIN_PLATFORM_MAP = {
  [JINDUO_DESIGN_BMS]: '展示设计部',
  [PLATFORM_BMS]: '金舵账号授权管理系统',
  [STORE_BMS]: '金舵门店管理后台',
  [ZHEJIANG_BMS]: '新零售管理后台（浙江区域）',
  [PRODUCT_CENTER_BMS]: '金舵产品中心'
}

export const SUERP_ADMIN_PLATFORM_ARR = Object.keys(SUERP_ADMIN_PLATFORM_MAP).map(key => ({
  id: parseInt(key),
  title: SUERP_ADMIN_PLATFORM_MAP[key]
}))
